export function AlgorithmExplanation() {
    return (
        <div className="bg-white p-6 rounded-lg shadow-lg w-1/2">
            <h2 className="text-2xl font-bold mb-4">Flood Fill Algorithm (BFS)</h2>
            <a
                href="https://leetcode.com/problems/flood-fill/description/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:text-blue-700 underline"
            >
                LeetCode Question Link
            </a>

            <div className="prose">
                <h3>How it Works:</h3>
                <ol className="list-decimal pl-6">
                    <li className="mb-2">
                        <strong>Starting Point:</strong> When you click a pixel, we get its color and position.
                    </li>
                    <li className="mb-2">
                        <strong>Queue Initialization:</strong> Add the starting pixel to a queue and create a visited set.
                    </li>
                    <li className="mb-2">
                        <strong>BFS Process:</strong>
                        <ul className="list-disc pl-6 mt-1">
                            <li>Take a pixel from the queue</li>
                            <li>Check if it matches the target color</li>
                            <li>If it matches, color it and add unvisited neighbors to queue</li>
                        </ul>
                    </li>
                    <li className="mb-2">
                        <strong>Neighbor Check:</strong> For each pixel, we check four adjacent pixels (up, right, down, left).
                    </li>
                    <li className="mb-2">
                        <strong>Termination:</strong> Continue until the queue is empty.
                    </li>
                </ol>

                <h3 className="mt-4">Time Complexity:</h3>
                <p>O(n) where n is the number of pixels in the connected region</p>

                <h3 className="mt-4">Space Complexity:</h3>
                <p>O(n) for the queue and visited set</p>

                <div className="bg-gray-100 p-4 rounded-lg mt-4">
                    <h4 className="font-bold">Pro Tips:</h4>
                    <ul className="list-disc pl-6">
                        <li>Use the fill tool for large areas of the same color</li>
                        <li>The brush tool is better for detailed drawing</li>
                        <li>The eraser helps fix mistakes</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}